module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.titles), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-item",
      class: i === _vm.value ? 'active-item' : '',
      style: ({
        'flex-basis': 100 / _vm.titles.length + 'vw'
      }),
      on: {
        "click": function($event) {
          _vm.handleClick(i)
        }
      }
    }, [_vm._v("\n    " + _vm._s(item) + "\n    "), (i === _vm.value) ? _c('div', {
      staticClass: "bottom-line"
    }) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-358a8d04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/top-tab.vue
// module id = 839
// module chunks = 34